import { render, staticRenderFns } from "./radar.vue?vue&type=template&id=639828c2&scoped=true"
import script from "./radar.vue?vue&type=script&lang=js"
export * from "./radar.vue?vue&type=script&lang=js"
import style0 from "./radar.vue?vue&type=style&index=0&id=639828c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639828c2",
  null
  
)

export default component.exports